import { useState, useEffect } from "react";
import {
  Loading,
  SecondaryContainer as CommonContainer,
  Pagination,
} from "components";
import { useRouter } from "next/router";
import { useLocale } from "hooks";
import PersonCard from "./components/PersonCard";
import translation from "./translation";

import { simapGetProfessorsNormalizer } from "utils/simapNormalizer";
import { simapService } from "services/client/SimapService";
import Search from "./components/Search";
import { useForm } from "react-hook-form";

const ITEMS_PER_PAGE = 8;

function Professors({ simap_id }) {
  const router = useRouter();
  const { locale } = useLocale();
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPagesCount, setTotalPagesCount] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [response, setResponse] = useState({});
  const methods = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
    },
  });
  const fetchData = async () => {
    if (simap_id) {
      try {
        setLoading(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
        const params = {
          groupId: simap_id,
          limit: ITEMS_PER_PAGE,
          offset: (currentPage - 1) * ITEMS_PER_PAGE,
        };
        const { firstName = "", lastName = "" } = methods.getValues();

        if (firstName) {
          if (locale === 'fa') {
            params.first_name_fa = firstName;
          } else {
            params.first_name_en = firstName;
          }
        }

        if (lastName) {
          if (locale === 'fa') {
            params.last_name_fa = lastName;
          } else {
            params.last_name_en = lastName;
          }
        }

        const res = await simapService.getProfessorsList(params);
        setResponse(simapGetProfessorsNormalizer(res?.data, locale));
        setTotalPagesCount(Math.ceil((res?.data?.count || 0) / ITEMS_PER_PAGE));
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [router.query, currentPage]);

  function handlePageClick(d) {
    setCurrentPage((d?.selected || 0) + 1);
  }

  const onSearch = () => {
    fetchData()
  }

  const renderList = () => {
    if (response?.results?.length % 2 === 0)
      return (
        <div className="tw-grid tw-gap-5 lg:tw-grid-cols-2 tw-mt-6">
          {response?.results?.map((item) => (
            <PersonCard {...item} />
          ))}
        </div>
      );

    return (
      <>
        <div className="tw-grid tw-gap-5 lg:tw-grid-cols-2 tw-mt-6">
          {response?.results?.slice(0, -1)?.map((item) => (
            <PersonCard {...item} />
          ))}
        </div>
        <div className="tw-flex tw-w-full lg:tw-w-1/2 tw-mx-auto tw-justify-center tw-mt-5">
          <PersonCard {...response?.results?.at?.(-1)} />
        </div>
      </>
    );
  };

  return (
    <>
      <CommonContainer className="tw-px-4 md:tw-px-0 tw-pb-8">
        <div>
          {loading ? (
            <div className="tw-min-h-[200px] tw-flex tw-items-center tw-justify-center loading">
              <Loading />
            </div>
          ) : (
            <div>
              <Search onSearch={onSearch} register={methods.register} />
              {response?.results?.results?.length === 0 ? (
                <div className="tw-text-center">
                  {translation[locale]?.NOT_FOUND}
                </div>
              ) : (
                renderList()
              )}
              <div className="tw-mt-5">
                <Pagination
                  currentPage={currentPage}
                  handlePageClick={handlePageClick}
                  totalPagesCount={totalPagesCount}
                />
              </div>
            </div>
          )}
        </div>
      </CommonContainer>
    </>
  );
}

export default Professors;
